<template>
    <div>
        <v-layout wrap vuetify-grid>
            <v-flex xs12 sm6 md6 sm-side-padding>
                <v-menu
                    v-model="menuFrom"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                >
                    <v-text-field
                        slot="activator"
                        v-model="dateFrom"
                        label="Date From"
                        readonly
                        solo
                        clearable
                    />
                    <v-date-picker v-model="dateFrom" @input="updateCalendar($event, 'menuFrom')" />
                </v-menu>
            </v-flex>

            <v-flex xs12 sm6 md6 sm-side-padding>
                <v-menu
                    v-model="menuTo"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                >
                    <v-text-field
                        slot="activator"
                        v-model="dateTo"
                        label="Date to"
                        readonly
                        solo
                        clearable
                    />
                    <v-date-picker v-model="dateTo" @input="updateCalendar($event, 'menuTo')" />
                </v-menu>
            </v-flex>
        </v-layout>

        <table id="SimpleLogTable" class="table " style="width:100%" />
    </div>
</template>

<script>
export default {

    name: "SimpleLogTable",

    data () {
        return {
            dateFrom: null,
            dateFromFormatted: null,
            menuFrom: false,

            dateTo: null,
            dateToFormatted: null,
            menuTo: false,
        };
    },
    watch: {
        dateFrom() {
            this.dateFromFormatted = null;
            if (this.dateFrom) {
                this.dateFromFormatted = moment(this.dateFrom).local().format();
            }
            this.redrawTable();
        },
        dateTo() {
            this.dateToFormatted = null;
            if (this.dateTo) {
                this.dateToFormatted = moment(this.dateTo).local().format();
            }
            this.redrawTable();
        }
    },
    mounted() {
        var date = new Date();
        var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        this.dateFromFormatted = moment(firstDay).local().format();
        this.dateToFormatted = moment(lastDay).local().format();

        this.dateFrom = moment(firstDay).format("YYYY-MM-DD");
        this.dateTo = moment(lastDay).format("YYYY-MM-DD");
    
        this.drawTable();
    },
    methods: {
  	drawTable() {
            var self = this;
  		$("#SimpleLogTable").DataTable(dataTableOption({
  			"ajax": {
  				"url": "SimpleLog/GetAll",
  			},
                "data": {
                    DateFrom: this.dateFromFormatted,
                    DateTo: this.dateToFormatted,
                },
  			"columnDefs": [
  			{ targets: "_all", defaultContent: "-" },
  			],
  			"columns": [
  			{ data: "id", title: "ID" },
  			{ data: "description", title: "Activity",render: function(data, type, row, meta) {
          
                        var myVariable = data.match(/{.*?}/g);
  				var newActivity = data.slice();

  				myVariable.forEach(item => {
                            var firstMatch = item.match(/\S+:/g).toString();
                            var FIRST_KEY  = firstMatch.replace(/{|:|}/g, "");
            
                            var secondMatch = item.match(/:\S+/g).toString();
                            var SECOND_KEY  = secondMatch.replace(/{|:|}/g, "");

                            var value;

  					switch (FIRST_KEY) {
  					  case "creatorUser":
  					    value = ((row[FIRST_KEY] || {}).userName || SECOND_KEY);
  					    break;
  					  case "trial":
                                if ((row[FIRST_KEY] || {}).id) {
                                    value = "<a href='/trial-detail/" + (row[FIRST_KEY] || {}).id + "' class='tableLinkID' data-passingID=" + (row[FIRST_KEY] || {}).id + " data-detailPage='TrialDetail'>" + ((row[FIRST_KEY] || {}).trialNumber) + "</a>";
                                }
                                else value = SECOND_KEY;
  					    break;
  					  case "palmRecording":
                                if ((row[FIRST_KEY] || {}).id) {
                                    value = "<a href='/experiment-palm-recording-detail/" + (row[FIRST_KEY] || {}).id + "' class='tableLinkID' data-passingID=" + (row[FIRST_KEY] || {}).id + " data-detailPage='EXPPalmRecordingDetail'>" + ((row[FIRST_KEY] || {}).id) + "</a>";
                                }
                                else value = SECOND_KEY;
  					    break;
  					  case "sampling":
                                if ((row[FIRST_KEY] || {}).id) {
                                    value = "<a href='/sampling-detail/" + (row[FIRST_KEY] || {}).id + "' class='tableLinkID' data-passingID=" + (row[FIRST_KEY] || {}).id + " data-detailPage='SamplingDetail'>" + ((((row[FIRST_KEY] || {}).qrCode || {}).code)) + "</a>";
                                }
                                else value = SECOND_KEY;
  					    break;
  					  case "palm":
                                if ((row[FIRST_KEY] || {}).id) {
                                    var part1 = (((row[FIRST_KEY] || {}).trial || {}).trialNumber || "-");
                                    var part2 = ((row[FIRST_KEY] || {}).trialPalmNumber || "-") ;
                                    var part3 = (((row[FIRST_KEY] || {}).progeny || {}).code || "-");
                                    value = "<a href='/palm-detail/" + (row[FIRST_KEY] || {}).id + "' class='tableLinkID' data-passingID=" + (row[FIRST_KEY] || {}).id + " data-detailPage='PalmDetail'>" + part1 + "/" + part2 + "(" + part3 + ")" + "</a>";
                                }
                                else value = SECOND_KEY;
  					    break;
  					  case "progeny":
                                if ((row[FIRST_KEY] || {}).id) {
  					     value = "<a href='/progeny-detail/" + (row[FIRST_KEY] || {}).id + "' class='tableLinkID' data-passingID=" + (row[FIRST_KEY] || {}).id + " data-detailPage='ProgenyDetail'>" + ((row[FIRST_KEY] || {}).code) + "</a>";
  					    }
                                else value = SECOND_KEY;
                                break;
  					  case "room":
                                if ((row[FIRST_KEY] || {}).id) {
    					    value = "<a href='/room-detail/" + (row[FIRST_KEY] || {}).id + "' class='tableLinkID' data-passingID=" + (row[FIRST_KEY] || {}).id + " data-detailPage='RoomDetail'>" + (((row[FIRST_KEY] || {}).qrCode || {}).code) + "</a>";
                                }
                                else value = SECOND_KEY;
    					    break;
  					  case "user":
  					    value = ((row[FIRST_KEY] || {}).userName || SECOND_KEY);
  					    break;
  					}

  					newActivity = newActivity.replace(item, "<strong>" + value + "</strong>");
  				});

  				return newActivity;
  				}
  			},
  			{ data: "creationTime", title: "Created at", render: function(date) { return moment(date).local().format("ll LTS"); } },
                ],
                "exportTitle": "Simple Log Table",
            }));
        // this.$store.commit('tableLinkID', '#SimpleLogTable');
  	},
        updateCalendar(date, menuType) {
            this[menuType] = false;
        },
        redrawTable() {
            if ($.fn.DataTable.isDataTable("#SimpleLogTable")) {   
                $("#SimpleLogTable").DataTable().destroy();
                $("#SimpleLogTable").empty();
            }
            this.drawTable();
        },
    }
};
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/components/UMS/AuditLog/SimpleLogTable.vue